import * as React from 'react';
import { ReactElement, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import { SxProps, Theme } from '@mui/material';
import { backgroundColorDarkTheme } from '../../styles/global.styles';

interface ChipData {
  key: number;
  label: string;
}

interface ChipListComponentProps {
  chipData: string[];
  chipIcon?: ReactElement;
  onDelete: (index: number) => void;
  chipSx?: SxProps<Theme>;
  maxChipWidth?: string | number;
}

const ListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const ChipListComponent = ({
  chipData,
  onDelete,
  chipIcon,
  chipSx,
  maxChipWidth = 300,
}: ChipListComponentProps) => {
  const [values, setValues] = useState<string[]>([]);

  const onDeleteChip = (index: number) => {
    setValues(values.filter((_, i) => i !== index));
    onDelete(index);
  };

  useEffect(() => {
    setValues(chipData);
  }, [chipData]);

  return (
    <Paper
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        p: 0.5,
        m: 0,
        backgroundColor: '#343434',
      }}
      component="ul"
    >
      {values.map((data, index) => {
        return (
          <ListItem key={index}>
            <Chip
              sx={{
                backgroundColor: backgroundColorDarkTheme,
                maxWidth: maxChipWidth,
                '& .MuiChip-label': {
                  display: 'block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
                ...chipSx,
              }}
              icon={chipIcon ?? <></>}
              label={data}
              title={data}
              onDelete={() => onDeleteChip(index)}
            />
          </ListItem>
        );
      })}
    </Paper>
  );
};

export default ChipListComponent;
